import { render, staticRenderFns } from "./sectionFive.vue?vue&type=template&id=d438e81c&scoped=true&"
import script from "./sectionFive.vue?vue&type=script&lang=js&"
export * from "./sectionFive.vue?vue&type=script&lang=js&"
import style0 from "./sectionFive.vue?vue&type=style&index=0&id=d438e81c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d438e81c",
  null
  
)

export default component.exports